import styled from 'styled-components';

export const SelectPlaceholder = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	width: ${(props) => props.$width}px;
	min-height: ${(props) => props.$minHeight};
	padding: 2px 8px;
	font-size: ${(props) => props.$fontSize}px;
	color: #000;
	background-color: #fff;
	border: 1px solid hsl(0, 0%, 80%);
	border-radius: 10px;
	cursor: pointer;
	text-align: left;

	&:focus-visible {
		outline: 2px solid #2684ff;
	}
`;

export const PlaceholderLabel = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
